import React from 'react';
import logo from './asserts/titelineLogo.png';
import './App.css';
import Navigation from "./components/Navigation/Navigation";
import {Route, Routes} from "react-router-dom";
import {SignInPage} from "./pages/SignInPage/SignInPage";
import {DDR2ApprovePage} from "./pages/DDR2ApprovePage/DDR2ApprovePage";
import {ViewDDRPage} from "./pages/ViewDDRPage/ViewDDRPage";
import {GetTheAppPage} from "./pages/GetTheAppPage/GetTheAppPage";
import {SubmittedDDR} from "./pages/SubmittedDDR/SubmittedDDR";
import EnvironmentBadge from './components/EnvironmentBadge/EnvironmentBadge';

function App() {
  return (
      <div className="container">
          <EnvironmentBadge />
          <div className="content">
              <div className="header">
                  <img className="logo" src={logo} alt="Logo" />
              </div>
              <div className="navigation">
                  <Navigation />
              </div>
              <Routes>
                  <Route path="/" element={<SignInPage/>} />
                  <Route path="/ddr-2-approve" element={<DDR2ApprovePage/>}/>
                  <Route path="/view-ddr" element={<ViewDDRPage/>}/>
                  <Route path="/submitted-ddr" element={<SubmittedDDR/>} />
                  <Route path="/get-the-app" element={<GetTheAppPage/>}/>
              </Routes>
              <div className="footer">
                  DORS WEB ENTRY
              </div>
          </div>
      </div>
  );
}

export default App;
